





















import { defineComponent } from '@vue/composition-api'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { faCommentAlt } from '@fortawesome/free-regular-svg-icons'

export default defineComponent({
  name: 'TextPopup',
  components: { FontAwesomeIcon },
  setup() {
    return {
      commentAlt: faCommentAlt,
      pencilAlt: faPencilAlt
    }
  }
})
